"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Slide.default;
  }
});
Object.defineProperty(exports, "unstable_StrictModeSlide", {
  enumerable: true,
  get: function get() {
    return _StrictModeSlide.default;
  }
});

var _Slide = _interopRequireDefault(require("./Slide"));

var _StrictModeSlide = _interopRequireDefault(require("./StrictModeSlide"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Slide/index.js
// module id = 229
// module chunks = 0